export const aranjamente_florale = [
    {
        id: "1",
        path: "/Aranjamente-florale/Flori-in-cutie",
        name: "Flori in cutie",
        cName: "nav-dropdown"
    },
    {
        id: "2",
        path: "/Aranjamente-florale/Cosuri-cu-flori",
        name: "Cosuri cu flori",
        cName: "nav-dropdown"
    },
    {
        id: "3",
        path: "/Aranjamente-florale/Aranjamente-corporate",
        name: "Aranjamente corporate",
        cName: "nav-dropdown"
    },
    {
        id: "4",
        path: "/Aranjamente-florale/Plante",
        name: "Plante",
        cName: "nav-dropdown"
    },
    {
        id: "5",
        path: "/Aranjamente-florale/Trandafiri-criogenati",
        name: "Trandafiri criogenati",
        cName: "nav-dropdown"
    },
    {
        id: "6",
        path: "/Aranjamente-florale/Coronite-flori",
        name: "Coronite flori",
        cName: "nav-dropdown"
    },
    {
        id: "7",
        path: "/Aranjamente-florale/Inimi-Florale",
        name: "Inimi Florale",
        cName: "nav-dropdown"
    },
]